<template>
    <div v-if="banner.title || banner.image_url" class="dashboard-banner">
        <div class="dashboard-banner__content">
            <h3 v-if="banner.title" class="dashboard-banner__title">{{ banner.title }}</h3>
            <a
                v-if="banner.cta_label && banner.cta_url"
                :href="banner.cta_url"
                class="dashboard-banner__cta"
            >
                {{ banner.cta_label }}
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
            </a>
        </div>
        <div v-if="banner.image_url" class="dashboard-banner__image-wrap">
            <img :src="banner.image_url" :alt="banner.title" class="dashboard-banner__image">
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardBanner',

    data() {
        return {
            banner: {
                title: '',
                subtitle: '',
                image_url: '',
                cta_label: '',
                cta_url: '',
            },
        };
    },

    mounted() {
        axios.get('/api/customer/dashboard-banner')
            .then(({ data }) => {
                this.banner = data;
            })
            .catch(() => {});
    },
}
</script>

<style scoped>
.dashboard-banner {
    background: #00abc8;
    border-radius: 5px;
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    overflow: hidden;
    width: 100%;
}

@media (min-width: 992px) {
    .dashboard-banner {
        flex-direction: row;
        padding: 0 2.5rem 2rem 2.5rem;
    }
}

.dashboard-banner__content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
    padding-top: 0;
    text-align: center;
    align-items: center;
}

@media (min-width: 992px) {
    .dashboard-banner__content {
        padding-top: 2rem;
        text-align: left;
        align-items: flex-start;
    }
}

.dashboard-banner__title {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 1.5rem;
    color: #ffffff;
    margin: 0;
}

@media (min-width: 992px) {
    .dashboard-banner__title {
        font-size: 22px;
        line-height: 2rem;
    }
}

.dashboard-banner__cta {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    align-self: center;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: #00abc8;
    background: #ffffff;
    border-radius: 4px;
    padding: 12px 20px;
    text-decoration: none;
    margin-top: 4px;
}

@media (min-width: 992px) {
    .dashboard-banner__cta {
        align-self: flex-start;
    }
}

.dashboard-banner__cta:hover,
.dashboard-banner__cta:focus {
    background: #f0fbfd;
    color: #00abc8;
    text-decoration: none;
}

.dashboard-banner__image-wrap {
    flex-shrink: 0;
    max-width: 100%;
    max-height: 180px;
    overflow: hidden;
    border-radius: 4px;
}

@media (min-width: 992px) {
    .dashboard-banner__image-wrap {
        max-width: 280px;
    }
}

.dashboard-banner__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
</style>
